@if (visible) {
  <div class="modal-backdrop">
    <div class="modal-window">

      <div class="modal-content">
        <h2>{{ title }}</h2>
        <p class="modal-description">
          A recomendação é calculada com base nas suas respostas ao questionário. Sua pontuação indica o perfil de investimento mais alinhado aos seus objetivos, experiência e tolerância a riscos.
          A pontuação abaixo indica a faixa de perfil recomendado, servindo como referência para entendimento da sua recomendação.
        </p>

        <div class="modal-score-card">
          <div class="ruler-container">

            <!-- Pontuação atual -->
            <div class="score-pointer" [style.left.%]="scorePercentage">
              <span class="pointer-value">{{ score }} pts</span>
              <span class="pointer-label">Pontuação atual</span>
              <div class="pointer-line"></div>
            </div>

            <!-- Régua de perfis -->
            <div class="ruler-bar">

              <div
                *ngFor="let seg of segmentos"
                class="bar-segment"
                [class.is-primeiro]="seg.isPrimeiro"
                [class.is-ultimo]="seg.isUltimo"
                [style.flex]="'0 0 ' + seg.largura + '%'"
                [style.background-color]="seg.cor"
                [style.--segment-color]="seg.cor"
              >

                <span class="bar-label">
                  {{ seg.titulo }}
                </span>

              </div>
            </div>
          </div>
        </div>

        <div class="modal-actions d-flex justify-content-center">
          <button class="btn btn-outline-primary" type="button" (click)="handleClose()">Entendi</button>
        </div>
      </div>
    </div>
  </div>
}